import { Text } from "../../../../../components/Text/text";
import { FbWhite, MetaIcon } from "../../../../../assets";
import {
  Container,
  ButtonCopiar,
  ButtonSalvar,
  ErrorMessage,
  MyIconButton,
  Relative,
  WhatsappBusiness,
  MyLink,
  LinkTemplates
} from "./styles";
import { useEffect, useRef, useState } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  setBotActiveMeta,
  setBotPhone,
  setBotTokenMeta,
  setBotURLMeta,
  setBotBusinessPhoneId,
  setBotBusinessAccountId,
  setUpdateModalWhatsapp,
  setBotWhatsName
} from "../../../../../redux/slices/bot";
import { css } from "@emotion/react";
import { Toast } from "primereact/toast";
import { Controller, useForm } from "react-hook-form";
import { InputText } from "../../../../../components";
import { v } from "../../../../../util";
import { zodResolver } from "@hookform/resolvers/zod";
import BotsServices from "../../../../../services/bots";
import { ProgressSpinner } from "primereact/progressspinner";
import { setToast } from "../../../../../redux/slices/user";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import FacebookServices from "../../../../../services/facebook";
import { useToast } from "../../../../../components/toast-provider";
import { AuthContextType, useAuth } from "../../../../../auth/auth-provider";
import { useNavigate } from "react-router-dom";
import { MdSpaceDashboard, MdViewModule, MdViewQuilt } from "react-icons/md";
import { Dialog } from "primereact/dialog";

interface ILeftContentWhatsappModal {
  show: (open: boolean) => void;
}

interface IPages {
  id: string;
  name: string;
  url: string;
  active: true;
  updatedAt: string;
}
interface retornoFbLogin {
  userName: string;
  userPictureUrl: string;
  id: string;
  pages: IPages[];
}

declare global {
  interface Window {
    fbAsyncInit?: () => void;
    FB?: any;
  }
}

export const LeftContentWhatsappModal: React.FC<ILeftContentWhatsappModal> = ({
  show
}) => {
  const counterToast = useAppSelector(
    (state) => state.user.toastApp?.count || 0
  );
  const schema = v.object({
    name: v.string().superRefine(v.nonempty()),
    phone: v.string().superRefine(v.nonempty()),
    token: v.string().superRefine(v.nonempty()),
    metaUrl: v.string().superRefine(v.nonempty()).superRefine(v.url()),
    businessPhoneId: v.string().superRefine(v.nonempty()),
    businessAccountId: v.string().superRefine(v.nonempty()),
    on: v.boolean()
  });
  const botResumeWhats = useAppSelector((state) => state.bot.whats);
  const [loading, setLoading] = useState(false);
  const [loadingOauth, setLoadingOauth] = useState(false);
  const botId = useAppSelector((state) => state.bot.id);
  const updateModalWhatsapp = useAppSelector(
    (state) => state.bot.updateModalWhatsapp
  );
  const [botConnected, setBotConnected] = useState<boolean>(false);
  const [showButtonDesconect, setShowButtonDesconect] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const { user } = useAuth() as AuthContextType;
  const [code, setCode] = useState<string | null>(null);
  const [wabaId, setWabaId] = useState<string | null>(null);
  const [phoneNumberId, setPhoneNumberId] = useState<string | null>(null);
  const [confirmCloseModal, setConfirmCloseModal] = useState(false);
  const lockWhatsappFields = botConnected;
  const navigate = useNavigate();
  const whatsappFieldStyle = {
    background: lockWhatsappFields ? "#D1D5DB" : "transparent"
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues
  } = useForm({
    defaultValues: {
      name: "",
      phone: "",
      token: "",
      metaUrl: "",
      businessPhoneId: "",
      businessAccountId: "",
      on: false
    },
    reValidateMode: "onSubmit",
    resolver: zodResolver(schema)
  });
  const { UpdateWhatsapp, GetWhatsappBusiness, disconnectWhatsappAccount } =
    BotsServices();
  const dispatch = useAppDispatch();
  const toastRef = useRef<Toast>(null);
  const toast = useToast();

  const [showButtonFacebook, setShowButtonFacebook] = useState(false);
  const [checkStorage, setCheckStorage] = useState(false);
  const [baseURL, setBaseURL] = useState("");
  const botTokenActive = useAppSelector(
    (state) => state.flowInteractions.tokenActive
  );
  const botIdActive = useAppSelector(
    (state) => state.flowInteractions.botIdActive
  );
  const [childWindow, setChildWindow] = useState(null);
  const [fbPagesLogin, setFbPagesLogin] = useState<retornoFbLogin>(
    {} as retornoFbLogin
  );
  const {
    getFbPages,
    connectFbPage,
    disconnectFbPage,
    disconnectMetaAccount,
    wppOauth,
    disconnectBot
  } = FacebookServices();

  const checkFbAuthentication = async () => {
    try {
      if (botIdActive > 0) {
        const retorno = await getFbPages({
          botId: botIdActive,
          type: "FACEBOOK"
        });
        setFbPagesLogin(retorno);
        setLoading(false);
      }
    } catch (error) {
      toast?.current?.show({
        life: 5000,
        severity: "error",
        summary: "Erro.",
        detail: `Conexão não Não foi possível buscar os dados neste momento! Por favor, tente mais tarde. ${JSON.stringify(
          error
        )}`,
        sticky: false
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    setBaseURL(`${window.location.origin.toString()}`);
    checkFbAuthentication();
  }, [botIdActive]);

  useEffect(() => {
    const fetchWhatsappBusiness = async () => {
      const response = await GetWhatsappBusiness(botId);
      const {
        accounts,
        name,
        phone,
        token,
        url,
        phoneId,
        accountId,
        botConnected
      } = response || {};

      setBotConnected(!!botConnected);

      if (accounts) {
        setShowButtonFacebook(false);
        setShowButtonDesconect(true);
        setAccounts(
          accounts.map((account: any) => ({
            ...account,
            label: `${account.phone} - ${account.name}`,
            value: account
          }))
        );

        const matchedAccount = accounts.find((acc: any) => acc.phone === phone);

        if (matchedAccount) {
          setSelectedAccount(matchedAccount);
          setValue("name", matchedAccount.name || "");
          setValue("phone", matchedAccount.phone);
          setValue("token", matchedAccount.token || token || "");
          setValue("metaUrl", matchedAccount.url || url || "");
          setValue(
            "businessPhoneId",
            matchedAccount.whastappBusinessPhoneId || phoneId || ""
          );
          setValue(
            "businessAccountId",
            matchedAccount.whastappBusinessAccountId || accountId || ""
          );
        } else {
          setSelectedAccount(null);
          setValue("name", "");
          setValue("phone", "");
          setValue("token", "");
          setValue("metaUrl", "");
          setValue("businessPhoneId", "");
          setValue("businessAccountId", "");
        }
      } else {
        setShowButtonFacebook(true);
        setShowButtonDesconect(false);
        setValue("name", name || "");
        setValue("phone", phone || "");
        setValue("token", token || "");
        setValue("metaUrl", url || "");
        setValue("businessPhoneId", phoneId || "");
        setValue("businessAccountId", accountId || "");
      }
    };

    fetchWhatsappBusiness();
  }, [botId, updateModalWhatsapp]);

  const changeAccount = (e: any) => {
    const selectedAccount = e.value;
    setSelectedAccount(selectedAccount);

    if (selectedAccount) {
      setValue("name", selectedAccount.name || "");
      setValue("phone", selectedAccount.phone || "");
      setValue("token", selectedAccount.token || "");
      setValue("metaUrl", selectedAccount.url || "");
      setValue(
        "businessPhoneId",
        selectedAccount.whastappBusinessPhoneId || ""
      );
      setValue(
        "businessAccountId",
        selectedAccount.whastappBusinessAccountId || ""
      );
    }
  };

  const disconnectUserWhatsapp = async () => {
    setLoading(true);
    const values = getValues();

    try {
      await disconnectWhatsappAccount(botId, {
        name: values.name,
        phone: values.phone,
        token: values.token,
        metaUrl: values.metaUrl,
        businessPhoneId: values.businessPhoneId,
        businessAccountId: values.businessAccountId
      });
    } catch (e: any) {
      toast?.current?.show({
        life: 5000,
        severity: "error",
        summary: "Erro.",
        detail: `Erro ao desconectar-se da conta neste momento! Por favor, tente mais tarde. ${JSON.stringify(
          e.description
        )}`,
        sticky: false
      });
    } finally {
      setLoading(false);
      dispatch(setUpdateModalWhatsapp(!updateModalWhatsapp));
    }
  };

  // const openChildWindow = () => {
  //   const newWindow = window.open(
  //     `https://www.facebook.com/v18.0/dialog/oauth?client_id=${process.env.WHATSAPP_APP_ID}&redirect_uri=${baseURL}/whatsapp/Oauth&state=${botTokenActive}&response_type=code&scope=business_management,whatsapp_business_management`,
  //     "_blank"
  //   );
  //   setChildWindow(newWindow);
  // };

  useEffect(() => {
    if (childWindow) {
      const timer = setInterval(() => {
        if (childWindow.closed) {
          clearInterval(timer);
          dispatch(setUpdateModalWhatsapp(!updateModalWhatsapp));
          toast?.current?.show({
            life: 5000,
            severity: "success",
            summary: "Autenticação realizada com sucesso!",
            detail: "Escolha seu número de telefone e salve as informações.",
            sticky: false
          });
        }
      }, 500);

      return () => clearInterval(timer);
    }
  }, [childWindow]);

  useEffect(() => {
    const appId = process.env.WHATSAPP_APP_ID as string;
    if (!appId) {
      return;
    }

    if (!document.getElementById("facebook-jssdk")) {
      const s = document.createElement("script");
      s.id = "facebook-jssdk";
      s.src = "https://connect.facebook.net/en_US/sdk.js";
      s.async = true;
      s.defer = true;
      document.body.appendChild(s);
    }

    window.fbAsyncInit = function () {
      window.FB.init({ appId, xfbml: true, version: "v24.0" });
    };
  }, []);

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      let { data } = event;

      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch {
          return;
        }
      }

      if (data?.type !== "WA_EMBEDDED_SIGNUP") return;

      if (data?.event === "FINISH") {
        setWabaId(data?.data?.waba_id ? String(data.data.waba_id) : null);
        setPhoneNumberId(
          data?.data?.phone_number_id ? String(data.data.phone_number_id) : null
        );
        return;
      }

      toast?.current?.show({
        life: 6000,
        severity: "warn",
        summary: "Atenção",
        detail:
          "Selecione um número de telefone para continuar no cadastro via OAuth da WABA. Sem um número vinculado, não é possível finalizar a configuração.",
        sticky: false
      });
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  const fbLoginCallback = (response: any) => {
    const c = response?.authResponse?.code;

    if (c) {
      setCode(String(c));
    }
  };

  const launchWhatsAppSignup = () => {
    const configId = process.env.WHATSAPP_OAUTH_CONFIG_ID as string;

    window.FB.login(fbLoginCallback, {
      config_id: configId,
      response_type: "code",
      override_default_response_type: true,
      extras: { version: "v3" }
    });
  };

  useEffect(() => {
    if (!code || !botTokenActive || !wabaId || !phoneNumberId) return;

    (async () => {
      setLoadingOauth(true);
      try {
        const resp = await wppOauth(
          code,
          botTokenActive,
          wabaId,
          phoneNumberId
        );

        const backendMessage =
          resp?.data?.message ??
          resp?.message ??
          "OAuth do WhatsApp concluído e enviado para o backend.";

        toast?.current?.show({
          life: 5000,
          severity: "success",
          summary: "Sucesso.",
          detail: backendMessage,
          sticky: false
        });
      } catch (e: any) {
        const backendMessage =
          e?.response?.data?.message ??
          e?.response?.data?.detail ??
          e?.message ??
          "Falha ao enviar o OAuth para o backend.";

        toast?.current?.show({
          life: 5000,
          severity: "error",
          summary: "Erro.",
          detail: backendMessage,
          sticky: false
        });
      } finally {
        setLoadingOauth(false);
        dispatch(setUpdateModalWhatsapp(!updateModalWhatsapp));
      }
    })();
  }, [code, wabaId, phoneNumberId, botTokenActive]);

  const disconnectBotConfirmed = async () => {
    setLoading(true);

    try {
      await disconnectBot(botId);

      toast?.current?.show({
        life: 4000,
        severity: "success",
        summary: "Sucesso.",
        detail: "Robô desconectado com sucesso.",
        sticky: false
      });

      setConfirmCloseModal(false);
      dispatch(setUpdateModalWhatsapp(!updateModalWhatsapp));
    } catch (e: any) {
      toast?.current?.show({
        life: 5000,
        severity: "error",
        summary: "Erro.",
        detail:
          e?.response?.data?.message ||
          e?.message ||
          "Erro ao desconectar o robô.",
        sticky: false
      });
    } finally {
      setLoading(false);
      setConfirmCloseModal(false);
    }
  };

  return (
    <Container>
      {loadingOauth && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(0,0,0,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <ProgressSpinner
            style={{ width: "100px", height: "100px" }}
            strokeWidth="4"
            fill="var(--surface-ground)"
            animationDuration=".6s"
          />
        </div>
      )}
      <Toast ref={toastRef} />
      {/* <div className="flex">
        <MyIconButton>
          <img src={MetaIcon} alt="Meta-Icon" />
        </MyIconButton>
        <div className="ml-3">
          <Text
            fontSize="0.9375rem"
            fontWeight={600}
            lineHeight="1.25rem"
            color="#0A043C"
          >
            Integração com o WhatsApp
          </Text>
          <Text
            fontSize="0.75rem"
            fontWeight={400}
            lineHeight="1.125rem"
            color="#544F77"
          >
            Integre o seu número de Whatsapp com a Meta Business Suite.
          </Text>
        </div>
      </div> */}
      <form
        onSubmit={handleSubmit(async (d) => {
          setLoading(true);
          await UpdateWhatsapp(botId, {
            name: d.name,
            phone: d.phone,
            token: d.token,
            metaUrl: d.metaUrl,
            businessPhoneId: d.businessPhoneId,
            businessAccountId: d.businessAccountId,
            active: d.on
          })
            .then(() => {
              dispatch(setBotWhatsName(d.name));
              dispatch(setBotPhone(d.phone));
              dispatch(setBotTokenMeta(d.token));
              dispatch(setBotURLMeta(d.metaUrl));
              dispatch(setBotBusinessPhoneId(d.businessPhoneId));
              dispatch(setBotBusinessAccountId(d.businessAccountId));
              dispatch(setBotActiveMeta(d.on));
              dispatch(
                setToast({
                  count: counterToast + 1,
                  show: true,
                  life: 3000,
                  severity: "success",
                  summary: "Sucesso.",
                  detail: "Dados Whatsapp atualizados.",
                  sticky: false
                })
              );
              setLoading(false);
              show(false);
            })
            .catch(() => {
              setLoading(false);
              dispatch(
                setToast({
                  count: counterToast + 1,
                  show: true,
                  severity: "error",
                  summary: "Erro ao gravar dados Whatsapp.",
                  detail: "Favor tentar novamente mais tarde.",
                  life: 3000
                })
              );
            });
        })}
      >
        <WhatsappBusiness>
          {!botConnected ? (
            showButtonFacebook ? (
              <MyLink onClick={launchWhatsAppSignup} rel="noreferrer">
                <img src={FbWhite} alt="facebook" />
                Ir para o Facebook
              </MyLink>
            ) : (
              <Dropdown
                style={{ width: "180px" }}
                value={selectedAccount}
                options={accounts}
                onChange={changeAccount}
                optionLabel="label"
                placeholder="Selecione uma conta"
              />
            )
          ) : null}
        </WhatsappBusiness>

        {botConnected && (
          <LinkTemplates
            role="link"
            onClick={() => navigate("/whatsapp-templates")}
          >
            <div className="icon">
              <MdSpaceDashboard />
            </div>

            <div className="content">
              <div className="title">Acessar templates</div>
              <div className="text">
                Gerencie seus templates de mensagem do WhatsApp
              </div>
            </div>

            <i className="pi pi-external-link" />
          </LinkTemplates>
        )}

        <div
          className="mt-4 gap-5 flex flex-column align-items-center justify-content-start"
          style={{ width: "98%" }}
        >
          <div className="w-full">
            <div
              style={{
                width: "inherit",
                marginTop: "1rem",
                cursor: "not-allowed"
              }}
              className="p-float-label"
            >
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <InputText
                    {...field}
                    id="name"
                    type="text"
                    readOnly={lockWhatsappFields}
                    style={whatsappFieldStyle}
                  />
                )}
              />
              <label htmlFor="name">Nome</label>
            </div>

            {errors?.name && (
              <ErrorMessage>{errors.name?.message}</ErrorMessage>
            )}
          </div>
          <div className="w-full">
            <div
              style={{ width: "inherit", cursor: "not-allowed" }}
              className="p-float-label"
            >
              <Controller
                name="phone"
                control={control}
                render={({ field }) => (
                  <InputText
                    {...field}
                    id="phone"
                    type="text"
                    readOnly={lockWhatsappFields}
                    style={whatsappFieldStyle}
                    // autoClear={false}
                    // mask={/^\(\d{2}\) 9/ugmi.test(field.value) ? "(99) 99999-9999" : "(99) 9999 999 9999"}
                    // placeholder={/^\(\d{2}\) 9/ugmi.test(field.value) ? "(99) 99999-9999" : "(99) 9999 999 9999"}
                    // slotChar="_"
                  />
                )}
              />
              <label htmlFor="phone">Número de telefone</label>
            </div>
            {errors?.phone && (
              <ErrorMessage>{errors.phone?.message}</ErrorMessage>
            )}
          </div>
          <div className="w-full">
            <div style={{ width: "inherit" }} className="p-float-label">
              <Controller
                name="token"
                control={control}
                render={({ field }) => (
                  <InputText
                    {...field}
                    id="token"
                    readOnly={lockWhatsappFields}
                    style={whatsappFieldStyle}
                  />
                )}
              />
              <label htmlFor="token">Token</label>
            </div>
            {errors?.token && (
              <ErrorMessage>{errors.token?.message}</ErrorMessage>
            )}
          </div>
          <div className="w-full">
            <div style={{ width: "inherit" }} className="p-float-label">
              <Controller
                name="metaUrl"
                control={control}
                render={({ field }) => (
                  <InputText
                    {...field}
                    id="host"
                    readOnly={lockWhatsappFields}
                    style={whatsappFieldStyle}
                  />
                )}
              />
              <label htmlFor="host">URL Meta</label>
            </div>
          </div>
          <div className="w-full">
            <div style={{ width: "inherit" }} className="p-float-label">
              <Controller
                name="businessPhoneId"
                control={control}
                render={({ field }) => (
                  <InputText
                    {...field}
                    id="businessPhoneId"
                    readOnly={lockWhatsappFields}
                    style={whatsappFieldStyle}
                  />
                )}
              />
              <label htmlFor="businessPhoneId">
                Identificação do número de telefone
              </label>
            </div>
          </div>
          <div className="w-full">
            <div style={{ width: "inherit" }} className="p-float-label">
              <Controller
                name="businessAccountId"
                control={control}
                render={({ field }) => (
                  <InputText
                    {...field}
                    id="businessAccountId"
                    readOnly={lockWhatsappFields}
                    style={whatsappFieldStyle}
                  />
                )}
              />
              <label htmlFor="businessAccountId">
                Identificação da conta do WhatsApp Business
              </label>
            </div>
          </div>
          <Relative>
            <div className="relative w-full">
              <div style={{ width: "inherit" }} className="p-float-label">
                <InputText
                  readOnly={true}
                  value={botResumeWhats?.urlWebhook}
                  style={{ background: "#D1D5DB", paddingRight: "3rem" }}
                />
                <label htmlFor="host1">URL WebHook</label>
              </div>
            </div>
            <ButtonCopiar
              onClick={() => {
                navigator.clipboard.writeText(botResumeWhats?.urlWebhook);
                toastRef.current?.show({
                  severity: "success",
                  detail: "URL Webhook copiado com sucesso!"
                });
              }}
            >
              Copiar
            </ButtonCopiar>
          </Relative>

          <div className="flex align-items-center">
            <Text
              fontSize="0.875rem"
              fontWeight={400}
              lineHeight="1.3125rem"
              color="#6D6F6F"
            >
              Ambiente:
            </Text>
            <Text
              style={{ marginLeft: "0.5rem" }}
              fontSize="0.875rem"
              fontWeight={600}
              lineHeight="1.3125rem"
              color="#046AF3"
            >
              Produção
            </Text>
            <div className="ml-4 flex align-items-center">
              <Controller
                name="on"
                control={control}
                render={({ field: { onChange } }) => (
                  <InputSwitch
                    checked={botResumeWhats.on}
                    onChange={(e) => {
                      onChange(e.value);
                      dispatch(setBotActiveMeta(e.value));
                    }}
                  />
                )}
              />
              <div className="ml-2">
                <Text
                  fontSize="0.875rem"
                  fontWeight={400}
                  lineHeight="1.3125rem"
                  color="#6D6F6F"
                >
                  {`${botResumeWhats?.on ? "Ativo" : "Inativo"}`}
                </Text>
              </div>
            </div>
          </div>
        </div>
        <div
          className="flex justify-content-center align-items-center"
          style={{ height: "5rem", gap: "1rem" }}
        >
          {showButtonDesconect && (
            <Button
              onClick={disconnectUserWhatsapp}
              label="Desconectar"
              className="p-button-outlined p-button-danger"
              style={{ width: "170px", height: "42px" }}
            />
          )}

          {botConnected && (
            <Button
              type="button"
              label="Desconectar"
              className="p-button-danger"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "170px",
                height: "42px",
                borderRadius: "8px",
                fontWeight: "600"
              }}
              onClick={() => setConfirmCloseModal(true)}
            />
          )}

          <ButtonSalvar
            disabled={loading}
            style={{
              border: "none",
              background: user.plataform.mainColor
                ? user.plataform.mainColor
                : "#2624CD"
            }}
          >
            {loading && (
              <ProgressSpinner
                style={{ width: "16px", height: "16px", margin: "0.2rem" }}
                strokeWidth="8"
                fill="var(--surface-ground)"
                animationDuration=".5s"
              />
            )}
            Salvar
          </ButtonSalvar>
        </div>
      </form>
      <Dialog
        visible={confirmCloseModal}
        onHide={() => setConfirmCloseModal(false)}
        draggable={false}
        header="Deseja desconectar o robô?"
        style={{ width: "575px" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            Ao continuar, o robô será desconectado da conta do WhatsApp.
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              gap: "15px"
            }}
          >
            <Button
              label="Sim"
              className="p-button-danger"
              onClick={disconnectBotConfirmed}
            />
            <Button
              label="Não"
              className="p-button-secondary"
              onClick={() => setConfirmCloseModal(false)}
            />
          </div>
        </div>
      </Dialog>
    </Container>
  );
};
